import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

/**
 * Упрощает получение search-параметров с помощью react-router
 * Работает как на сервере, так и в браузере
 * @param search — строка с параметрами, если не указано используется search-часть URL текущей страницы
 */
function useSearchParams(search?: string) {
  const location = useLocation();

  const searchParams = useMemo(() => {
    return new URLSearchParams(search || location.search);
  }, [location.search, search]);

  return searchParams;
}

export default useSearchParams;
